/**
 * Created by bob.gear on 30/05/2015.
 */
/*
Now here's the thing - all of the project summary  controllers and layouts are called from
the search module.

This is not what I  want longer term. There is a base class for the project summary which
should be able to exist in one module, then I want to be able to subclass (prototypically)
in another module so that, notifications, say, can inherit and extend the behaviour
 */
angular.module('EICDataStream3.pdfReportService') // <-- add dependencies here
  .controller('ProjectReportSummaryController',
    [
      '$scope', '$stateParams', '$state', '$interval', '$location', 'projectReportSummaryDataService',
      'trackingStatusService', 'pdfReportService', 'reportRequestService', 'summaryDownloadService',
      'geographicalProjectPresenterService', 'exportRequestService', 'fileDownloadService',
      'FEATURE_SWITCHES',
      function ($scope,
        $stateParams,
        $state,
        $interval,
        $location,
        projectReportSummaryDataService,
        trackingStatusService,
        pdfReportService,
        reportRequestService,
        summaryDownloadService,
        geographicalProjectPresenterService,
        exportRequestService,
        fileDownloadService,
        FEATURE_SWITCHES) {

        $scope.componentName = "ProjectReportSummaryController";

        $scope.FEATURE_SWITCHES = FEATURE_SWITCHES;
        $scope.NEW_EXPORTS = FEATURE_SWITCHES.NEW_EXPORTS;


        $scope.projectReportSummaryDataService = projectReportSummaryDataService;

        $scope.dataFlowControl = projectReportSummaryDataService.dataFlowControl;
        $scope.trackingStatusService = trackingStatusService;
        $scope.pdfReportService = pdfReportService;

        // use the report guid to fetch back the characteristics of the watch - name etc.
        $scope.reportGuid = $stateParams.guid;
        $scope.reportStatuses = pdfReportService.reportStatuses;

        $scope.projectPresentation = {
          highlightSince: "",
          newSince: ""
        };






        $scope.returnToReportList = function () {
          $state.go("reports.managePdfReports");
        }

        $scope.btnRunReport = function () {
          $scope.report.status = $scope.reportStatuses.queued;
          pdfReportService.runReport($scope.reportGuid);
        };

        $scope.btnDelete = function () {
          pdfReportService.delete($scope.reportGuid)
            //    .then($scope.cancelRefreshInterval)
            .then($scope.returnToReportList);
        };

        $scope.btnCancelReport = function (report) {
          $scope.report.status = $scope.reportStatuses.cancelling;
          pdfReportService.cancelReport(report.reportId);
        };

        $scope.btnSave = function () {
          pdfReportService.updateProperties($scope.reportGuid, $scope.report)
            .then(function () {
              $scope.report.isEditing = false;
            })
            .catch(function (e) {
              var i = 1;
            });
        };

        $scope.btnDownloadPdfReport = function (url) {
          fileDownloadService.downloadFile(url);
        }

        //$scope.enableWatch = function(watch) {
        //  watchService.enableWatch(watch);
        //};

        //$scope.$watch("dataFlowControl.guid", function(){
        //  if (!$scope.dataFlowControl.guid) return;
        //  $scope.source = "projectwatch";
        //  $scope.summaryGuid = $scope.dataFlowControl.guid;

        //  $scope.projectPresentation.updatedSince = (!$scope.dataFlowControl.lastNotified) ? 'never'
        //    : $scope.dataFlowControl.lastNotified;

        //  //$scope.projectPresentation.highlightSince = (!$scope.dataFlowControl.lastNotified) ? $scope.dataFlowControl.created
        //  //  : $scope.dataFlowControl.lastNotified;
        //  $scope.projectPresentation.highlightSinceDate =$scope.dataFlowControl.highlightSinceDate;
        //  //$scope.projectPresentation.selectedTrackingStatuses = $scope.projectPresentation.selectedTrackingStatuses;
        //});


        //$scope.$watch("projectWatchSummaryDataService.dataFlowControl.queryDef", function(){
        //  if (!projectWatchSummaryDataService.dataFlowControl.queryDef) return;
        //
        //$scope.projectPresentation.highlightSince = (!$scope.dataFlowControl.queryDef.lastNotified) ? 'never'
        //  : $scope.dataFlowControl.queryDef.lastNotified;
        //
        //$scope.projectPresentation.newSince = (!$scope.dataFlowControl.queryDef.lastNotified) ? $scope.dataFlowControl.queryDef.created
        //  : $scope.dataFlowControl.queryDef.lastNotified;
        //
        //
        //}, true);




        /**************************************************************************
         *  Project Selections
         **************************************************************************/
        // Function to determine if any projects in the list have been selected
        // This is used to determine which options are available on the
        // Actions menu.
        $scope.areAnyProjectsChecked = function () {
          return ($scope.projectSelectionSummary.numberOfProjectsSelected > 0);
        }
        $scope.areAllProjectsChecked = function () {
          return ($scope.projectSelectionSummary.areAllProjectsSelected);
        }
        // this structure is passed into the Projects display directive.
        // it allows values to be passed out again, as well as pre and post
        // selection special actions
        $scope.projectSelectionSummary = {
          projectSelecting: function (projectID, isChecked) { },
          projectSelected: function (projectID, isChecked) { },

          numberOfProjectsSelected: 0,
          areAnyProjectsSelected: false,
          areAllProjectsSelected: false,
          projectIDs: [],
          resetSelections: function () {
            this.projectIDs.length = 0;
          }
        };

        /**************************************************************************
         *   Action Menu
         **************************************************************************/
        $scope.currentPath = function () {
          // ie objects to the # character and ignores everything that  follows it.
          // Encoding the # in hex (%23) allows outlook to  process the url properly
          // when called from ie
          return $location.absUrl().replace("#", "%23");
        };


        $scope.exportSummary = function () {
          return summaryDownloadService.pdfReport($scope.reportGuid);
        };

        $scope.removeSelectedProjects = function () {
          // Gather up the list of selected projects and send back to the pdf report
          // controller in a suitably formatted patch

          pdfReportService.removeProjects({
            reportGuid: $scope.reportGuid,
            projectIDs: $scope.projectSelectionSummary.projectIDs
          }).then(function () {
            for (var i = 0; i < $scope.dataFlowControl.items.length; i++) {
              var item = $scope.dataFlowControl.items[i];
              if ($scope.projectSelectionSummary.projectIDs.indexOf(item.projectID) > -1) {
                $scope.dataFlowControl.items[i].excluded = true;
              }
            }
            // experiment - here is a possible place to unselect the selected projects
            $scope.projectSelectionSummary.resetSelections();

          });
        };



        //$scope.stopWatchingSelectedProjects = function () {
        //  // Gather up the list of selected projects and send back to the project watch
        //  // controller in a suitably  formatted patch

        //  watchService.stopWatchingProjects({
        //    watchGuid: $scope.watchGuid,
        //    projectIDs: $scope.projectSelectionSummary.projectIDs
        //  }).then(function () {
        //    for (var i = 0; i < $scope.dataFlowControl.items.length; i++) {
        //      var item = $scope.dataFlowControl.items[i];
        //      if ($scope.projectSelectionSummary.projectIDs.indexOf(item.projectID) > -1) {
        //        $scope.dataFlowControl.items[i].excluded = true;
        //      }
        //    }
        //    // experiment - here is a possible place to unselect the selected projects
        //    $scope.projectSelectionSummary.resetSelections();

        //  });
        //};



        $scope.restoreProject = function (projectID) {
          // here we send off a request via the watchService to  restore the project
          return pdfReportService.restoreProject($scope.reportGuid, projectID)
            .then(function () {
              // sort out the project's style
              for (var i = 0; i < $scope.dataFlowControl.items.length; i++) {
                var item = $scope.dataFlowControl.items[i];
                if (item.projectID === projectID) {
                  $scope.dataFlowControl.items[i].excluded = false;
                }
              };
            });
        };


        $scope.share = function () {
          return "mailto:?subject=Search Result from EICDataStream&body=I thought you might be interested in this list of projects from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A"
            .replace("{{currentPath}}", $scope.currentPath());
        };


        $scope.actionMenu = {
          items: [
            // {
            //   text: "Export Summary",
            //   actionType: "function",
            //   action: $scope.exportSummary,
            //   visible: function () { return !$scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED; },
            //   disabled: $scope.areAnyProjectsChecked
            // },
            {
              text: "Export Summary...",
              actionType: "function",
              action: exportRequestService.openProjectExportRequestDialog,
              visible: function () {
                // return true;
                return $scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED && !$scope.NEW_EXPORTS.SUSPENDED;
              },
              disabled: function () { return false }
            },
            {
              text: "Export Service Suspended",
              actionType: "function",
              action: function () { },
              visible: function () {
                return $scope.NEW_EXPORTS.SUSPENDED;
              },
              disabled: function () { return true }
            },
            {
              text: "Remove projects from report",
              actionType: "function",
              action: $scope.removeSelectedProjects,
              visible: function () { return true; },
              disabled: function () {
                return !$scope.areAnyProjectsChecked() || $scope.areAllProjectsChecked();
              }
            },
            {
              isDivider: true,
              visible: function () {
                return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
              }
            },
            {
              text: "Show selected projects on a map... (Beta)",
              actionType: "function",
              action: geographicalProjectPresenterService.post_selectedProjects,
              visible: function () {
                return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
              },
              disabled: function () { return !$scope.areAnyProjectsChecked(); }
            }

            //,
            //{
            //  text: "PDF of results of this search...(new)",
            //  actionType:"function",
            //  action: $scope.openReportRequestDialog_searchResult,
            //  visible: function(){
            //    return !$scope.areAnyProjectsChecked() && $scope.NEW_REPORT_REQUEST.CRITERIA_PROJECTS_ENABLED
            //  },
            //  disabled: false
            //}
          ]
        };
        /**************************************************************************/
        $scope.reorderProjects = {};

        $scope.$on("SORT_CHANGED",
          function (event, sort) {
            $scope.reorderProjects.sortOrder = sort.sortField;
            $scope.reorderProjects.sortDesc = sort.sortDesc;

            projectReportSummaryDataService.search($scope.reportGuid, sort);
          });



        $scope.$on("PROJECTNAMES_FETCHED",
          function (event, projectList, sort) {
            $scope.reorderProjects.projectIDs = projectList.map(function (p) {
              return p.projectID;
            });
            $scope.reorderProjects.sortOrder = sort.sort_order;
            $scope.reorderProjects.sortDesc = sort.sort_desc;

            pdfReportService.reorderProjects($scope.reportGuid, $scope.reorderProjects);
          });



        var getreportProperties = function () {
          if ($scope.report && $scope.report.isEditing) return;

          // add status debouncing for cancelling/cancelled status
          pdfReportService.getReport($scope.reportGuid)
            .then(function (report) {
              if (!$scope.report) return report;

              if ($scope.report.status === $scope.reportStatuses.cancelling
                && $scope.report.status !== $scope.reportStatuses.cancelled) {
                $scope.report.status = $scope.reportStatuses.cancelling;
              }

              return report;
            })
            .then(function (report) {
              $scope.report = report;
            });

        }


        //projectSummaryDataService.nextPage = function () {
        //  // Guard conditions to prevent a search from runnning
        //  // i. search already in progress
        //  // ii. change of subject causing a nexpPage() call with no search criteria
        //  var noCriteriaSupplied = !searchService.queryDef.criteria || Object.keys(searchService.queryDef.criteria).length == 0;
        //  var noProjectListSupplied = !searchService.queryDef.projectIDs || searchService.queryDef.projectIDs.length == 0;

        //  if (projectSummaryDataService.dataFlowControl.busy) return;
        //  if (noCriteriaSupplied && noProjectListSupplied) return;

        //  // searchService.queryDef.paging.offset = searchService.queryDef.paging.offset + searchService.queryDef.paging.limit;
        //  searchService.queryDef.incrementPage();
        //  projectSummaryDataService.projectSearch();
        //};


        $scope.reportRefreshInterval = null;
        $scope.$on("$viewContentLoaded",
          function () {
            // getreportProperties();
            $scope.reportRefreshInterval = $interval(getreportProperties, 1000);
          });

        $scope.cancelRefreshInterval = function () {
          if ($scope.reportRefreshInterval)
            $interval.cancel($scope.reportRefreshInterval);
        };

        $scope.$on("$destroy", $scope.cancelRefreshInterval);

        // search method kicks the whole process off by  giving a searchID
        // which is retrieved and used to  fetch the first page

        if (!pdfReportService.report) {
          pdfReportService.getReport($scope.reportGuid)
            .then(function () {
              projectReportSummaryDataService.search($scope.reportGuid, pdfReportService.initialSort);

            });
        } else {
          projectReportSummaryDataService.search($scope.reportGuid, pdfReportService.initialSort);
        }


      }
    ]);
